<section class="events-page">
  <!-- Page Header -->
  <div class="page-header mb-3">
    <h3 class="title mb-1">Events</h3>
    <p class="subtitle mb-0">Manage and monitor all events in your organization</p>
  </div>

  <!-- Filters -->
  <div class="filters-row d-flex gap-3 align-items-center mb-3 justify-content-between" [formGroup]="filterForm">
    <div class="d-flex gap-3 align-items-center">
      <div class="search-group" style="flex: 0 1 350px;">
        <div class="search-input-wrap">
          <i class="pi pi-search search-icon"></i>
          <input pInputText formControlName="search" class="search-input" placeholder="Search..." style="border-radius: 8px;" />
        </div>
      </div>

      <div class="filter-group">
        <p-select formControlName="status" [options]="statusOptions" optionLabel="label" optionValue="value"
          placeholder="Select All" class="filter-dropdown" [style]="{'border-radius': '8px'}" />
      </div>
      
      @if (hasSelection()) {
        <button class="btn btn-icon btn-delete-bulk tooltip-wrap" (click)="deleteSelectedEvents()">
          <i class="pi pi-trash" style="font-size: 1.25rem;"></i>
          <span class="tooltip-box">Delete Selected</span>
        </button>
      }
    </div>

    <div class="d-flex align-items-center gap-3 ms-auto">
      <div class="d-flex align-items-center gap-2 border rounded px-1 header-icon-actions-wrapper">
        <button type="button" class="btn btn-icon p-1 header-icon-action-btn" (click)="loadEvents()" title="Refresh">
          <i class="pi pi-refresh" style="font-size: 1.25rem; color: #6b7280;"></i>
        </button>
        <button type="button" class="btn btn-icon p-1 tooltip-wrap header-icon-action-btn" (click)="toggleIncludeDeleted()">
          <i class="pi pi-asterisk" style="font-size: 1.25rem;" [style.color]="includeDeleted() ? '#ec4899' : '#6b7280'"></i>
          <span class="tooltip-box">Include Mark Deleted</span>
        </button>
      </div>
    </div>
  </div>

  <!-- Events Table -->
  <div class="table-container shadow" style="position: relative;">
    @if (isLoading()) {
    <div class="loading-overlay" style="position: absolute; inset: 0; background: rgba(255,255,255,0.7); display: flex; align-items: center; justify-content: center; z-index: 10;">
      <app-spinner-loader [width]="40" />
    </div>
    }

    <table class="events-table">
      <thead>
        <tr>
          <th class="checkbox-col" style="width: 48px; text-align: center;">
            <input type="checkbox" [checked]="allSelected()" (change)="toggleSelectAll()" />
          </th>
          <th>Event Name ⇅</th>
          <th>Host ⇅</th>
          <th>Status ⇅</th>
          <th>Date ⇅</th>
          <th class="text-center">Action</th>
        </tr>
      </thead>
      <tbody>
        @if (paginatedEvents().length === 0 && !isLoading()) {
        <tr>
          <td colspan="6" class="no-data-cell">No events found</td>
        </tr>
        } @else {
        @for (event of paginatedEvents(); track event._id) {
        <tr [class.selected]="event.selected">
          <td class="checkbox-col" style="text-align: center;">
            <input type="checkbox" [(ngModel)]="event.selected" (change)="updateSelectAllState()"
              [disabled]="event.status === 'Deleted' || event.status === 'deleted' || event.status === 'cancelled' || event.status === 'Cancelled'" />
          </td>
          <td>
            <p class="event-name">{{ event.title }}</p>
            <p class="event-desc-small" [title]="event.description">
              {{ event.description | slice:0:25 }}{{ event.description.length > 25 ? '...' : '' }}
            </p>
          </td>
          <td>
            <div class="host-cell">
              @if (event.host.image) {
              <img [src]="event.host.image" class="host-avatar-img" [alt]="event.host.name" />
              } @else {
              <div class="host-avatar" [style.background]="event.avatarBg">
                {{ event.initials }}
              </div>
              }
              <div class="host-info">
                <p class="event-name">{{ event.host.name || 'N/A' }}</p>
                <p class="event-desc-small">{{ event.host.email || 'N/A' }}</p>
              </div>
            </div>
          </td>
          <td>
            <span class="status-badge" [ngClass]="'status-' + event.status.toLowerCase()">
              {{ event.status }}
            </span>
          </td>
          <td class="date-cell">{{ event.dateFormatted }}</td>

          <td class="actions-cell text-center">
            <button class="btn btn-view" (click)="viewEvent(event)" title="View">View</button>
          </td>
        </tr>
        }
        }
      </tbody>
    </table>

    <div class="d-flex justify-content-between align-items-center mt-3 table-footer px-3 py-3" style="border-top: 1px solid #e5e7eb;">
      <div class="entries-info" style="color: #6b7280; font-size: 14px;">
        Showing {{ showingFrom }} to {{ showingTo }} of {{ totalCount() }} Entries
      </div>
      <div class="d-flex align-items-center gap-2">
        @if (events().length !== 0) {
        <label class="page-size-label mb-0" for="pageSizeSelect" style="color: #6b7280; font-size: 13px;">Page Size:</label>
        <select id="pageSizeSelect" [ngModel]="pageSize()" (ngModelChange)="onPageSizeChange($event)"
          class="form-select" style="font-size: 13px; padding: 5px 28px 5px 10px; border-radius: 6px; width: auto;">
          <option *ngFor="let size of pageSizes" [value]="size">
            {{ size }}
          </option>
        </select>
        }
        <button class="btn btn-outline pagination-btn ms-2"
          [disabled]="currentPage() === 1 || isLoading() || events().length === 0" (click)="prevPage()"
          style="font-size: 13px; padding: 6px 16px; border-radius: 6px;">
          &lt; Prev
        </button>
        <button class="btn btn-outline pagination-btn" [disabled]="currentPage() === totalPages || isLoading()"
          (click)="nextPage()" style="font-size: 13px; padding: 6px 16px; border-radius: 6px;">
          Next &gt;
        </button>
      </div>
    </div>
  </div>
</section>